import { render, staticRenderFns } from "./StockLocationsTab.vue?vue&type=template&id=0b264c68&"
import script from "./StockLocationsTab.vue?vue&type=script&lang=js&"
export * from "./StockLocationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports